module.exports = __webpack_public_path__ + "img/whats-new_en.83c6d7e.jpg";